import {get} from 'lodash'
export default function spotifyPreAddsAvailable(filter){
	const availableDate = new Date('2026-03-09');
	const filterDate = new Date(get(filter, 'global.dateEnd'));
	return (filterDate.getTime() - availableDate.getTime()) >= 0;
}
